import { Reveal } from "./Reveal";
import { recognition } from "../data/site";

export const RecognitionSection = ({ dark = false }) => (
  <section
    data-testid="recognition-section"
    className={`py-24 sm:py-32 ${dark ? "bg-navy-deep text-white" : "bg-white"}`}
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-12 sm:mb-16 max-w-2xl">
        <p className={`overline-label mb-4 ${dark ? "!text-white/50" : ""}`}>Awards &amp; recognition</p>
        <h2 className={`font-serif text-3xl sm:text-5xl tracking-tight leading-tight ${dark ? "text-white" : "text-ink"}`}>
          Appreciation from the institutions we've served
        </h2>
      </Reveal>
      <div className="grid sm:grid-cols-2 gap-6">
        {recognition.map((r, i) => (
          <Reveal
            key={r.source}
            delay={i * 0.06}
            className={`border border-gray-200 p-7 sm:p-9 flex flex-col sm:flex-row gap-6 sm:gap-7 items-start h-full ${dark ? "bg-navy-deep border-white/10" : "bg-white"} ${i === 0 ? "sm:col-span-2" : ""}`}
          >
            <div className={`w-full ${i === 0 ? "sm:w-64" : "sm:w-40"} shrink-0 overflow-hidden border border-gray-200 bg-navy-deep aspect-[4/3] group`}>
              <img
                src={r.img}
                alt={`Plaque — ${r.source}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div>
              <span className="block w-6 h-1 bg-brand mb-4" aria-hidden="true" />
              <h3 className={`font-serif tracking-tight leading-snug ${i === 0 ? "text-xl sm:text-2xl" : "text-lg sm:text-xl"} ${dark ? "text-white" : "text-navy"}`}>
                {r.source}
              </h3>
              <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-white/60" : "text-gray-500"}`}>{r.detail}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
